import Image from "next/image";
import React from "react";

import { TeracLetteringLogo } from "@/components/icons/TeracLetteringLogo";

interface NavigationLogoProps {
  className?: string;
}

export function NavigationLogo({ className }: NavigationLogoProps) {
  return (
    <div className={`flex items-center space-x-2 ${className || ""}`}>
      <Image
        src="/brand/logo.svg"
        alt="Terac Logo"
        width={24}
        height={24}
        className="size-6"
      />
      <TeracLetteringLogo className="h-6 w-auto" />
    </div>
  );
}
